module.exports = __webpack_public_path__ + "media/images/moving-van-e2b8f84ca69fa33194ee8d2bc5dd7d57.png";